import PasswordConfirmationPage from './pages/AccountSecurity/PasswordConfirmationPage';
import EmailVerificationPage from './pages/AccountSecurity/EmailVerificationPage';
import TwoFactorPage from './pages/AccountSecurity/TwoFactorPage';
import AccountAccessPage from './pages/AccountSecurity/AccountAccessPage';
import AdminDesignScope from './components/admin/AdminDesignScope';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import React from 'react';
import Navbar from './components/Navbar/Navbar';
import { POSProvider, usePOS } from './context/POSContext';
import NavbarPos from './pages/Admin/pos/NavbarPos';
import TopBar from './components/TopBar/TopBar';

import Login from './pages/Login';
import Register from './pages/Register';
import UsersPage from './pages/Users/UsersPage';
import NivelUsuariosPage from './pages/UsersLevel/NivelUsuariosPage';
import LogsActivityPage from './pages/logs/LogsActivityPage';
import LogsSecurityPage from './pages/logs/LogsSecurityPage';
import LandingPage from './pages/LandingPage/LandingPage';
import Aboutus from './pages/LandingPage/Aboutus';
import Services from './pages/LandingPage/Services';
import Contact from './pages/LandingPage/Contact';
import AdminPage from './pages/AdminPage';

import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import CelestialTransition from './components/common/CelestialTransition';
import ProtectedRoute from './routes/ProtectedRoute';
import PublicLayout from './components/layouts/PublicLayout';
import ServicePage from './pages/Admin/services/ServicePage';
import CategoryPage from './pages/Admin/categories/CategoryPage';
import CategoryHistoryPage from './pages/Admin/categories/CategoryHistoryPage';
import SpacePage from './pages/Admin/spaces/SpacePage';
import ServiceHistoryPage from './pages/Admin/services/ServiceHistoryPage';
import ServiciosLanding from './pages/LandingPage/Services/ServiciosLanding';
import PlansPage from './pages/Admin/plans/PlansPage';
import PlanHistoryPage from './pages/Admin/plans/PlanHistoryPage';
import PrecioPlanServicioPage from './pages/Admin/preciosplanes/PrecioPlanServicioPage';
import PrecioPlanServicioHistoryPage from './pages/Admin/preciosplanes/PrecioPlanServicioHistoryPage';
import SpaceHistoryPage from './pages/Admin/spaces/SpaceHistoryPage';
import SpaceServcicePage from './pages/Admin/spaceservice/SpaceServicePage';
import SpaceServiceHistoryPage from './pages/Admin/spaceservice/SpaceServiceHistoryPage';
import ClientsPage from './pages/Admin/clients/ClientsPage';
import PersonnelPage from './pages/Admin/Personnel/PersonnelPage';
import ProfilePage from './pages/Admin/profile/ProfilePage';
import ProfileLandingPage from './pages/LandingPage/Profile/ProfileLandingPage';
import PermissionPage from './pages/Admin/RoutesPermission/PermissionPage';
import { PermissionsProvider } from './context/PermissionsContext';
import PosPage from './pages/Admin/pos/PosPage';
import NuevaCitaPage from './pages/Admin/pos/NuevaCitaPage';
import PlanConfigPage from './pages/Admin/configplan/PlanConfigPage';
import UserLevelPermissionPage from './pages/Admin/modelpermission/UserLevelPermissionPage';
import CouponPage from './pages/Admin/coupon/CouponPage';
import UsedCouponPage from './pages/Admin/couponused/UsedCouponPage';
import CitaCouponDetallePage from './pages/Admin/couponused/CitaCouponDetallePage';
import SugerenciasCardList from './pages/Admin/pos/SugerenciasPanel';

import ClienteLayout from './components/NavbarHeader/ClienteLayout';
import MisCitasClientePage, { SolicitudesReservaClientePage } from './pages/LandingPage/Plataforma/MisCitas/MisCitasClientePage';
import MiDashboard from './pages/LandingPage/Plataforma/Dashboard/MiDashboard';
import DetallesCitaClientePage from './pages/LandingPage/Plataforma/MisCitas/DetallesCitaClientePage';
import CodigoOrdenPage from './pages/Admin/orden/CodigoOrdenPage';
import SesionesCitaPage from './pages/LandingPage/Plataforma/MisCitas/SesionesCitaPage';
import MisCotizacionesClientePage from './pages/LandingPage/Plataforma/MisCitas/MisCotizacionesClientePage';
import MisFacturasClientePage from './pages/LandingPage/Plataforma/MisCitas/MisFacturasClientePage';
import KardexCitasPage from './pages/Admin/kardex/KardexCitasPage';
import DetalleKardexClientesPage from './pages/Admin/kardex/DetalleKardexClientesPage';
import SesionKardexClientesPage from './pages/Admin/kardex/SesionKardexClientesPage';
import TiposPagosPage from './pages/Admin/tipospago/TiposPagosPage';
import RetornoClientesPage from './pages/Admin/clientes_retorno/RetornoClientesPage';
import SesionesPosPage from './pages/Admin/pos/SesionesPosPage';
import SesionDetallePage from './pages/Admin/pos/SesionDetallePage';
import PagosSesionPage from './pages/Admin/pos/PagosSesionPage';
import CodigoPagoPage from './pages/Admin/codigopago/CodigoPagoPage';
import PosConfigPage from './pages/Admin/pos/PosConfigPage';
import SesionesPOSGeneral from './pages/Admin/pos/SesionesPOSGeneral';
import ConfigHorasRegaloPage from './pages/Admin/horas_regalo/ConfigHorasRegaloPage';
import SucursalesPage from './pages/Admin/sucursales/SucursalesPage';
import ConfigCorrespondenciaPage from './pages/Admin/correspondencia/ConfigCorrespondenciaPage';
import CorrespondenciasPage from './pages/Admin/correspondencia/CorrespondenciasPage';
import AfiliadosPage from './pages/Admin/afiliados/AfiliadosPage';
import MiCorrespondenciaPage from './pages/LandingPage/Plataforma/Correspondencia/MiCorrespondenciaPage';
import SeguimientoPublicoPage from './pages/LandingPage/Plataforma/Correspondencia/SeguimientoPublicoPage';
import CodigoSesionPosPage from './pages/Admin/codigo_sesionpos/CodigoSesionPosPage';
import ConfigPagosPage from './pages/Admin/configpagos/ConfigPagosPage';
import HistorialPagosPage from './components/historial-pagos/HistorialPagosPage';
import ReservasPage from './pages/Admin/pos/ReservasPage';
import DetallesReservaPage from './pages/Admin/pos/DetallesReservaPage';
import EditarCitaPage from './pages/Admin/pos/EditarCitaPage';
import ReservasCalendarioPage from './pages/Admin/pos/ReservasCalendariaPage';
import TodayArrivalsReportPage from './pages/Admin/reportes/TodayArrivalsReportPage';
import DetalleVentaCafeteriaPage from './pages/Admin/pos/DetalleVentaCafeteriaPage';
import ReportsPage from './pages/Admin/reportes/ReportsPage';
import VerReservas from './pages/Admin/pos/VerReservas';
import HistorialPagosCitasPage from './components/historial-pagos/HistorialPagosCitasPage';
import ReglasNivelPage from './pages/Admin/reglas_nivel/ReglasNivelPage';

import { ROUTES } from './routes/routePaths.ts';
import AboutusProjects from './pages/LandingPage/AboutusProjects';
import ServicesOficinasPriv from './pages/LandingPage/ServicesOficinasPriv';
import ServicesSalaReu from './pages/LandingPage/ServicesSalasReu';
import Eventos from './pages/LandingPage/Eventos';
import ComunidadBanco from './pages/LandingPage/ComunidadBanco';
import ComunidadMiembros from './pages/LandingPage/CoMunidadMiembros';
import ComunidadNetworking from './pages/LandingPage/ComunidadNetworking';
import Blog from './pages/LandingPage/Blog';
import ServicioDetalle from './pages/LandingPage/Services/Serviciodetalle';
import ReservaYa from './pages/LandingPage/Plataforma/ReservaYa/ReservaYa';
import EspaciosCoworking from './pages/LandingPage/EspaciosCoworking';
import EspaciosEmpresarial from './pages/LandingPage/EspaciosEmpresarial';
import NuestrosClientes from './pages/LandingPage/NuestrosClientes';
import BlogCategoriaPage from './pages/Admin/blogs/BlogCategoriaPage';
import BlogPublicacionesPage from './pages/Admin/blogs/BlogPublicacionesPage';
import BlogDetalle from './pages/LandingPage/BlogDetalle';
import EmpresasConfianzaPage from './pages/Admin/empresaconfianza/EmpresasConfianzaPage';
import BannerHeroAdminPage from './pages/Admin/banner/BannerHeroAdminPage';
import RamasProfesionalesPage from './pages/Admin/ramas/RamasProfesionalesPage';
import EventosPage from './pages/Admin/eventos/EventosPage';
import EmpresaPage from './pages/Admin/empresa/EmpresaPage';
import FacturaDetallePage from './pages/Admin/empresa/FacturaDetallePage';
// Importaciones para WebSockets
import { WebSocketProvider } from './context/WebSocketContext';
import { MovimientoCajaWebSocketProvider } from './context/MovimientoCajaWebSocketContext';
// import { ConnectionStatus } from './components/websockets/ConnectionStatus';
import PagosPage from './pages/Admin/pagos/PagosPage';
import ProductsPage from './pages/Admin/products/ProductsPage';
import ProductsCategoryPage from './pages/Admin/products/ProductsCategoryPage';
import ParaTi from './pages/LandingPage/Plataforma/ParaTi/ParaTi';
// Sistema de notificaciones toast (usado por ParaTi y cualquier otra pantalla)
import { ToastProvider } from './components/common/ToastNotification';


// Layout para admin (con TopBar y Navbar)
const Layout = () => {
    return (
        <div className="flex flex-col h-screen bg-gray-50 dark:bg-[#0b0614] text-gray-900 dark:text-gray-100 transition-colors duration-300">
            <TopBar />
            <div className="border-b border-gray-200 dark:border-purple-900/40">
                <Navbar />
            </div>
            <div className="flex-1 overflow-y-auto bg-white dark:bg-[#0b0614] custom-scroll pt-4 text-gray-900 dark:text-gray-100">
                <Outlet />
            </div>
        </div>
    );
};

// Layout para Nueva Cita (sin TopBar, con NavbarPos)
const NuevaCitaLayout = () => {
    return (
        <POSProvider>
            <NuevaCitaLayoutContent />
        </POSProvider>
    );
};

const NuevaCitaLayoutContent = () => {
    const { sesionActiva, puntoDeVenta, cargandoSesion, operadorActivo, setOperadorActivo } = usePOS();

    if (cargandoSesion) {
        return <div aria-busy="true" style={{ minHeight: '100dvh', background: '#fff' }} />;
    }

    if (!sesionActiva) {
        return (
            <div className="h-screen flex items-center justify-center text-red-600 dark:bg-[#0b0614]">
                No hay sesión de POS activa
            </div>
        );
    }

    return (
        <div className="h-[100dvh] min-h-0 flex flex-col w-full max-w-full overflow-x-hidden bg-gray-50 dark:bg-[#0b0614] text-gray-900 dark:text-gray-100 transition-colors duration-300">
            <NavbarPos puntoDeVenta={puntoDeVenta} sesionActiva={sesionActiva} operadorActivo={operadorActivo} onOperatorChange={setOperadorActivo} />
            <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden bg-gray-50 dark:bg-[#0b0614] custom-scroll w-full text-gray-900 dark:text-gray-100">
                <Outlet />
            </div>
        </div>
    );
};

const App = () => {
    return (
        <ThemeProvider>
            <CelestialTransition />
            <Router>
                <AuthProvider>
                    <ToastProvider>
                        <PermissionsProvider>
                            <WebSocketProvider>
                                <MovimientoCajaWebSocketProvider>
                                    <Routes>
                                        <Route path={ROUTES.login} element={<Login />} />
                                        <Route path={ROUTES.register} element={<Register />} />
                                        <Route path={ROUTES.recuperarContrasena} element={<AccountAccessPage mode="recovery" />} />
                                        <Route path={ROUTES.cambiarContrasena} element={<AccountAccessPage mode="password" />} />
                                        <Route path={ROUTES.verificarAcceso} element={<AccountAccessPage mode="verify" />} />
                                        <Route element={<PublicLayout />}>
                                            <Route path={ROUTES.landingpage} element={<LandingPage />} />
                                            <Route path={ROUTES.coworking} element={<EspaciosCoworking />} />
                                            <Route path={ROUTES.empresarial} element={<EspaciosEmpresarial />} />
                                            <Route path={ROUTES.nuestrosClientes} element={<NuestrosClientes />} />
                                            <Route path={ROUTES.nosotrosHistoria} element={<Aboutus />} />
                                            <Route path={ROUTES.nosotrosProyectos} element={<AboutusProjects />} />
                                            <Route path={ROUTES.contacto} element={<Contact />} />
                                            <Route path={ROUTES.serviciosCowork} element={<Services />} />
                                            <Route path={ROUTES.serviciosOficinas} element={<ServicesOficinasPriv />} />
                                            <Route path={ROUTES.serviciosSalas} element={<ServicesSalaReu />} />
                                            <Route path={ROUTES.serviciosEventos} element={<Eventos />} />
                                            <Route path={ROUTES.comunidadBanco} element={<ComunidadBanco />} />
                                            <Route path={ROUTES.comunidadMiembros} element={<ComunidadMiembros />} />
                                            <Route path={ROUTES.comunidadNetworking} element={<ComunidadNetworking />} />
                                            <Route path={ROUTES.blog} element={<Blog />} />
                                            <Route path={ROUTES.blogDetalle} element={<BlogDetalle />} />
                                            <Route path={ROUTES.serviciosCategory} element={<ServiciosLanding />} />
                                            <Route path={ROUTES.serviciosDetalles} element={<ServicioDetalle />} />
                                        </Route>

                                        {/* Ruta pública de seguimiento de correspondencias */}
                                        <Route path={ROUTES.seguimientoPublico} element={<SeguimientoPublicoPage />} />

                                        {/* ========== RUTAS PROTEGIDAS ========== */}
                                        <Route element={<ProtectedRoute />}>
                                            <Route path={ROUTES.confirmarCambioContrasena} element={<PasswordConfirmationPage />} />
                                            <Route path={ROUTES.cambiarCorreo} element={<EmailVerificationPage mode="change" />} />
                                            <Route path={ROUTES.verificarCorreo} element={<EmailVerificationPage />} />
                                            <Route path={ROUTES.configurarDosPasos} element={<TwoFactorPage />} />
                                            <Route element={<ClienteLayout />}>
                                                <Route path={ROUTES.reservaYa} element={<ReservaYa />} />
                                                <Route path={ROUTES.misCitas} element={<MisCitasClientePage />} />
                                                <Route path={ROUTES.solicitudesReserva} element={<SolicitudesReservaClientePage />} />
                                                <Route path={ROUTES.misCotizaciones} element={<MisCotizacionesClientePage />} />
                                                <Route path={ROUTES.misFacturas} element={<MisFacturasClientePage />} />
                                                <Route path={ROUTES.misCitasDetalle} element={<DetallesCitaClientePage />} />
                                                <Route path={ROUTES.misCitasSesiones} element={<SesionesCitaPage />} />
                                                <Route path={ROUTES.perfil} element={<ProfileLandingPage />} />
                                                <Route path={ROUTES.miDashboard} element={<MiDashboard />} />
                                                <Route path={ROUTES.parati} element={<ParaTi />} />
                                                <Route path={ROUTES.miCorrespondencia} element={<MiCorrespondenciaPage />} />
                                            </Route>

                                            <Route element={<AdminDesignScope><Layout /></AdminDesignScope>}>
                                                <Route path={ROUTES.dashboard} element={<AdminPage />} />
                                                <Route path={ROUTES.usuarios} element={<UsersPage />} />
                                                <Route path={ROUTES.reglasNivel} element={<ReglasNivelPage />} />
                                                <Route path={ROUTES.nivelUsuarios} element={<NivelUsuariosPage />} />
                                                <Route path={ROUTES.userLevelPermisos} element={<UserLevelPermissionPage />} />
                                                <Route path={ROUTES.activity} element={<LogsActivityPage />} />
                                                <Route path={ROUTES.security} element={<LogsSecurityPage />} />
                                                <Route path={ROUTES.categoriasProductos} element={<ProductsCategoryPage />} />
                                                <Route path={ROUTES.productos} element={<ProductsPage />} />
                                                <Route path={ROUTES.services} element={<ServicePage />} />
                                                <Route path={ROUTES.servicesHistory} element={<ServiceHistoryPage />} />
                                                <Route path={ROUTES.categorias} element={<CategoryPage />} />
                                                <Route path={ROUTES.categoriesHistory} element={<CategoryHistoryPage />} />
                                                <Route path={ROUTES.spaces} element={<SpacePage />} />
                                                <Route path={ROUTES.spacesHistory} element={<SpaceHistoryPage />} />
                                                <Route path={ROUTES.spacesServices} element={<SpaceServcicePage />} />
                                                <Route path={ROUTES.spacesServicesHistory} element={<SpaceServiceHistoryPage />} />
                                                <Route path={ROUTES.plan} element={<PlansPage />} />
                                                <Route path={ROUTES.plansHistory} element={<PlanHistoryPage />} />
                                                <Route path={ROUTES.planConfig} element={<PlanConfigPage />} />
                                                <Route path={ROUTES.pricePlan} element={<PrecioPlanServicioPage />} />
                                                <Route path={ROUTES.pricePlanHistory} element={<PrecioPlanServicioHistoryPage />} />
                                                <Route path={ROUTES.posList} element={<PosPage />} />
                                                <Route path={ROUTES.reservas} element={<ReservasPage />} />
                                                <Route path={ROUTES.historialPagosCita} element={<HistorialPagosCitasPage />} />
                                                <Route path={ROUTES.reservasCalendario} element={<ReservasCalendarioPage />} />
                                                <Route path={ROUTES.reporteLlegadasHoy} element={<TodayArrivalsReportPage />} />
                                                <Route path={ROUTES.reporteCancelaciones} element={<ReportsPage />} />
                                                <Route path={ROUTES.reporteReservas} element={<ReportsPage />} />
                                                <Route path={ROUTES.reporteHorasRegalo} element={<ReportsPage />} />
                                                <Route path={ROUTES.reporteDeudas} element={<ReportsPage />} />
                                                <Route path={ROUTES.reportePagosSesiones} element={<ReportsPage />} />
                                                <Route path={ROUTES.reportePagos} element={<ReportsPage />} />
                                                <Route path={ROUTES.reporteCaja} element={<ReportsPage />} />
                                                <Route path={ROUTES.reporteUso} element={<ReportsPage />} />
                                                <Route path={ROUTES.reporteClientes} element={<ReportsPage />} />
                                                <Route path={ROUTES.reporteActividad} element={<ReportsPage />} />
                                                <Route path={ROUTES.reporteSeguridad} element={<ReportsPage />} />
                                                <Route path={ROUTES.ventasDetalle} element={<DetalleVentaCafeteriaPage />} />
                                                <Route path={ROUTES.reporteCafeteria} element={<ReportsPage />} />
                                                <Route path={ROUTES.reservasDetalle} element={<DetallesReservaPage />} />
                                                <Route path={ROUTES.reservasEditar} element={<EditarCitaPage />} />
                                                <Route path={ROUTES.posListSesiones} element={<SesionesPosPage />} />
                                                <Route path={ROUTES.sesionesPos} element={<SesionDetallePage />} />
                                                <Route path={ROUTES.sesionesPosPagos} element={<PagosSesionPage />} />
                                                <Route path={ROUTES.posConfig} element={<PosConfigPage />} />
                                                <Route path={ROUTES.coupon} element={<CouponPage />} />
                                                <Route path={ROUTES.couponUsed} element={<UsedCouponPage />} />
                                                <Route path={ROUTES.citaCouponDetalle} element={<CitaCouponDetallePage />} />
                                                <Route path={ROUTES.sugerenciasCitas} element={<SugerenciasCardList />} />
                                                <Route path={ROUTES.kardexCitas} element={<KardexCitasPage />} />
                                                <Route path={ROUTES.kardexCitasDetalle} element={<DetalleKardexClientesPage />} />
                                                <Route path={ROUTES.kardexHistorialPagos} element={<HistorialPagosPage />} />
                                                <Route path={ROUTES.configHorasRegalo} element={<ConfigHorasRegaloPage />} />
                                                <Route path={ROUTES.configCorrespondencia} element={<ConfigCorrespondenciaPage />} />
                                                <Route path={ROUTES.correspondencias} element={<CorrespondenciasPage />} />
                                                <Route path={ROUTES.afiliados} element={<AfiliadosPage />} />
                                                <Route path={ROUTES.kardexSesiones} element={<SesionKardexClientesPage />} />
                                                <Route path={ROUTES.tiposPago} element={<TiposPagosPage />} />
                                                <Route path={ROUTES.configPago} element={<ConfigPagosPage />} />
                                                <Route path={ROUTES.permission} element={<PermissionPage />} />
                                                <Route path={ROUTES.clients} element={<ClientsPage />} />
                                                <Route path={ROUTES.personnel} element={<PersonnelPage />} />
                                                <Route path={ROUTES.profile} element={<ProfilePage />} />
                                                <Route path={ROUTES.codigosOrden} element={<CodigoOrdenPage />} />
                                                <Route path={ROUTES.codigoPagoOrden} element={<CodigoPagoPage />} />
                                                <Route path={ROUTES.system} element={<RetornoClientesPage />} />
                                                <Route path={ROUTES.pagos} element={<PagosPage />} />
                                                <Route path={ROUTES.sesionesDePos} element={<SesionesPOSGeneral />} />
                                                <Route path={ROUTES.codigoSesionPosOrden} element={<CodigoSesionPosPage />} />
                                                <Route path={ROUTES.sucursales} element={<SucursalesPage />} />
                                                <Route path={ROUTES.empresa} element={<EmpresaPage />} />
                                                <Route path={ROUTES.facturaDetalle} element={<FacturaDetallePage />} />

                                                <Route path={ROUTES.blogCategoria} element={<BlogCategoriaPage />} />
                                                <Route path={ROUTES.blogPublicaciones} element={<BlogPublicacionesPage />} />
                                                <Route path={ROUTES.empresasConfianza} element={<EmpresasConfianzaPage />} />
                                                <Route path={ROUTES.bannerHero} element={<BannerHeroAdminPage />} />
                                                <Route path={ROUTES.ramasProfesionales} element={<RamasProfesionalesPage />} />
                                                <Route path={ROUTES.eventosAdmin} element={<EventosPage />} />
                                            </Route>

                                            <Route element={<AdminDesignScope><NuevaCitaLayout /></AdminDesignScope>}>
                                                <Route path={ROUTES.pointOfSale} element={<NuevaCitaPage />} />
                                                <Route path={ROUTES.pointOfSaleVerReservas} element={<VerReservas />} />
                                            </Route>
                                        </Route>

                                        <Route path="/landingpage" element={<Navigate to={ROUTES.landingpage} replace />} />
                                    </Routes>

                                    {/* 
                                  * Indicador de conexión WebSocket:
                                  * Comentado a nivel de sistema según solicitud de diseño.
                                  * Sirve como guía de desarrollo para saber si hay o no conexión WebSocket activa.
                                  * <ConnectionStatus />
                                */}
                                </MovimientoCajaWebSocketProvider>
                            </WebSocketProvider>
                        </PermissionsProvider>
                    </ToastProvider>
                </AuthProvider>
            </Router>
        </ThemeProvider>
    );
};

export default App;

